/* @ngInject */
const myWagonDisplayFields = () => {
  return {
    restrict: 'E',
    scope: {
      myWagon: '=',
    },
    template: require('./myWagonDisplayFields.html'),

    /* @ngInject */
    controller: ($scope, $$wagon) => {
      $scope.fields = $$wagon.metadata.fields
    },
    link: {
      pre: (scope, element, attrs) => {  },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}

export default myWagonDisplayFields



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/directives/display/myWagonDisplayFields.js